/**
 * Reduce a numerology number to a single digit (1..9), preserving the
 * master numbers 11/22/33 by default. Master numbers are surfaced as
 * "amplified" versions (11 = strong 2, 22 = strong 4, 33 = strong 6).
 *
 * Pass `preserveMaster: false` to always reduce to 1..9 (used in compat
 * lookup tables where master numbers don't matter).
 */
const MASTER_NUMBERS = new Set([11, 22, 33]);
export function reduceToDigit(n, preserveMaster = true) {
    let cur = Math.abs(n);
    while (cur > 9) {
        if (preserveMaster && MASTER_NUMBERS.has(cur))
            return cur;
        cur = String(cur).split('').reduce((acc, d) => acc + parseInt(d, 10), 0);
    }
    return cur;
}
export function isMaster(n) {
    return MASTER_NUMBERS.has(n);
}
//# sourceMappingURL=reduce.js.map